<template>
  <div class="search-con">
    <!-- 搜索类型下拉选择 -->
    <el-select 
      v-model="searchType" 
      class="search-type-select"
      size="small"
      @change="handleSearchTypeChange"
    >
      <el-option label="关键词" value="keywords"></el-option>
      <el-option label="词条" value="entries"></el-option>
    </el-select>
    
    <!-- 统一的搜索输入框 -->
    <div class="search-input-wrapper">
      <img class="search-icon" src="@/assets/editor/search.png" />
      
      <el-autocomplete
        class="search-box autocomplete-box"
        v-model="searchInput"
        :fetch-suggestions="getSuggestions"
        :trigger-on-focus="false"
        :placeholder="searchType === 'entries' ? '词条搜索进入气泡图' : '请输入内容进行搜索'"
        @select="handleSelect"
        @keyup.enter.native="handleInput"
        :debounce="300"
      >
        <template slot-scope="{ item }">
          <div class="suggestion-item">
            <i class="el-icon-search suggestion-icon"></i>
            <span class="suggestion-text">{{ item.value }}</span>
          </div>
        </template>
      </el-autocomplete>
    </div>
  </div>
</template>

<script>
import request from '@/http/request';
import { EventBus } from '@/main.js';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      searchInput: '',
      searchType: 'entries',
      searchResult: [],
      showSearchResult: true,
      offset: 0,
      limit: 10,
      isLoadingSearchList: false
    }
  },
  mounted() {
    this.$bus.$on('updateSearchInput', (keyword) => {
      this.searchInput = keyword;
    });
  },
  
  beforeDestroy() {
    this.$bus.$off('updateSearchInput');
  },
  computed: {
    ...mapState(['choosedResult'])
  },
  methods: {
    handleInput () {
      const input = this.searchInput.trim()
      
      if (this.searchType === 'entries') {
        if (input) {
          if (this.$route.path === '/editor/bubble') {
            this.$emit('triggerBubbleSearch', input)
          } else {
            this.$store.commit('setBubbleSearchKeyword', input)
            this.$router.push('/editor/bubble')
          }
        } else {
          this.$message({
            message: '请输入搜索内容',
            type: 'warning',
            duration: 1000
          })
        }
        return
      }
      
      this.searchResult = []
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        if (!this.isLoadingSearchList) {
          this.apiGetSearchResult(input)
        } else {
          this.$message({
            message: '请稍后',
            type: 'error',
            duration: 1000
          })
        }
        this.searchTimer = null
      }, 500)
    },

    handleSearchTypeChange () {
      this.searchInput = ''
      this.searchResult = []
    },

    async getSuggestions(queryString, cb) {
      if (!queryString || queryString.trim() === '') {
        cb([]);
        return;
      }
      
      if (this.searchType === 'entries') {
        await this.queryEntrySuggestions(queryString, cb);
      } else {
        cb([]);
      }
    },

    async queryEntrySuggestions(queryString, cb) {
      try {
        const result = await request('/api/Keywords/getKeywordsListByName', {
          keywords: queryString.trim()
        });
        
        if (!result) {
          cb([]);
          return;
        }
        
        let suggestionsList = [];
        
        if (Array.isArray(result)) {
          suggestionsList = result;
        } else if (result.result && Array.isArray(result.result)) {
          if (result.code !== 200) {
            cb([]);
            return;
          }
          suggestionsList = result.result;
        } else if (result.data && Array.isArray(result.data)) {
          suggestionsList = result.data;
        }
        
        const suggestions = suggestionsList.map(item => ({
          value: item.keywords || item.name || item
        })).filter(item => item.value);
        
        cb(suggestions.slice(0, 10));
      } catch (error) {
        cb([]);
      }
    },

    handleSelect(item) {
      this.searchInput = item.value;
      this.handleInput();
    },

    getTotal (keyword) {
      return new Promise((resolve, reject) => {
        request('/api/Paper/searchContentByTypeTotal', {
          query: keyword,
          type: 1
        }).then((result) => {
          resolve(result)
        })
      })
    },

    apiGetSearchResult (input) {
      request('api/Paper/searchContent', {
        query: input,
        page: 1,
        limit: 10,
        search_type: 'paper'
      }).then(async (result) => {
        const total = await this.getTotal(input)
        const list = result.paper_list.list
        this.$emit('openSearchBar', input, list, total)
      })
    },

    clickThesis (paperId, title, url) {
      // 后台上传的论文
      if (url.startsWith('https://oss.bookor.com.cn')) {
        this.apiAddPaper(paperId, title, url)
      } else {
        // 搜索网站获取的论文
        this.apiGetThesisMes(paperId, title, url)
      }
    },
    // 存本地的api
    apiGetThesisMes (id, title, url) {
      if (url) {
        this.apiAddPaper(id, title, url)
      } else {
        this.$message({
          message: '暂未搜索到pdf',
          type: 'error',
          duration: 1000
        })
      }
    },

    // 提交服务器的api
    apiAddPaper (paperId, title, url) {
      if (!url) {
        this.$message({
          message: '暂未搜索到对应文件',
          type: 'error',
          duration: 1000
        })
        return
      }
      const params = {
        paper_title: title,
        paper_url: url,
        paper_type: 'paper' // 区分上传的类型
      }
      request('/api/Paper/addPaper', params).then(() => {
        this.$message({
          message: '论文保存成功',
          type: 'success',
          duration: 1000
        })

        this.choosedResult.unshift(params)
        this.$store.commit('updateChoosedResult', this.choosedResult)
        // 新增完论文，直接展示
        const popData = {
          pdfUrl: url,
          title: title
        }
        this.$emit('getUrlData', popData)

        // 触发文档列表里论文数据的更新
        EventBus.$emit('refreshThesisList')
        this.showSearchResult = false
      }).catch(() => {
        this.$message({
          message: '此论文已存在',
          type: 'error',
          duration: 1000
        })
      })
    },

    handleScrollSearchResult (event) {
      const elem = event.target
      if (elem.scrollTop + elem.clientHeight >= elem.scrollHeight) {
        this.$message({
          message: '没有更多了',
          type: 'error',
          duration: 1000
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-con {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.search-type-select {
  width: 90px;
  
  ::v-deep .el-input__inner {
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
    font-size: 12px;
    border: 1px solid #666;
  }
  
  ::v-deep .el-input__suffix {
    right: 8px;
  }
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  width: 18px;
  height: 18px;
  position: absolute;
  left: 10px;
  z-index: 10;
  pointer-events: none;
}

.autocomplete-box {
  width: 35vw !important;
  margin: 8px 0;
  
  ::v-deep .el-input__inner {
    height: 24px !important;
    border: 1px solid black !important;
    border-radius: 14px !important;
    padding-left: 30px !important;
    font-size: 14px !important;
  }
  
  ::v-deep .el-input__prefix {
    display: none;
  }
}

.suggestion-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  
  .suggestion-icon {
    margin-right: 8px;
    color: #909399;
  }
  
  .suggestion-text {
    flex: 1;
  }
}
</style>
